// extracted by mini-css-extract-plugin
module.exports = {"container":"CheckboxOrRadio_container__uEqsH","input":"CheckboxOrRadio_input__DeSn_"};